<script>
import { industries } from '@site/data/products'
import AppIcon from '@site/components/common/AppIcon.vue'

export default {
  name: 'IndustrySection',
  components: { AppIcon },
  data() {
    return {
      industries,
      // 每个行业的场景痛点一句话（贴合行业）
      industryFootprints: {
        文创: '文创好物 · 多品类快速上新',
        饰品: '潮流饰品 · 款式多、SKU 杂',
        潮玩: '潮流玩具 · 盲盒整箱扫码出入库',
        谷子: '二次元周边 · IP 好物高频上新',
        服装: '时尚服饰 · 颜色尺码多维管理',
        珠宝: '精致珠宝 · 高单价会员复购',
        美妆: '潮流美妆 · 效期库存精细管控',
        手作: '原创手作 · 一件一码入册',
        杂货: '创意杂货 · 品类丰富一店装下',
      },
    }
  },
}
</script>

<template>
  <section class="section section--light" id="industries">
    <div class="container">
      <div class="section-head reveal">
        <span class="section-eyebrow">覆盖行业</span>
        <h2>九大审美零售行业，都懂你</h2>
        <p>潮玩、谷子、文创、饰品、珠宝、美妆……无论你卖什么好物，航富通都替你管得明明白白</p>
      </div>

      <div class="industry-grid">
        <div v-for="ind in industries" :key="ind.name" class="industry-card reveal" :style="{ '--c': ind.color }">
          <span class="industry-card__dot"></span>
          <h3>{{ ind.name }}</h3>
          <p>{{ industryFootprints[ind.name] }}</p>
        </div>
      </div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
.industry-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: $space-gap;
}

.industry-card {
  background: $color-bg-white;
  border-radius: $radius-lg;
  padding: 32px 28px;
  border: 1px solid rgba(139, 92, 246, 0.06);
  box-shadow: $shadow-sm;
  position: relative;
  overflow: hidden;
  transition: transform $motion-base $ease-out, box-shadow $motion-base $ease-out;

  &::after {
    content: '';
    position: absolute;
    top: -40px;
    right: -40px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: var(--c);
    opacity: 0.08;
    filter: blur(20px);
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: $shadow-md;
    border-color: var(--c);
  }

  &__dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--c);
    display: inline-block;
    margin-bottom: 16px;
  }

  h3 { font-size: $font-card; font-weight: $weight-bold; margin-bottom: 8px; }
  p { color: $color-text-muted; font-size: 14px; line-height: 1.6; }

  @media (max-width: $bp-md) {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: $bp-md) {
  .industry-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: $bp-sm) {
  .industry-grid { grid-template-columns: 1fr; }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/IndustrySection.vue